export default __webpack_public_path__ + "static/media/calendar-arrow-next.3508a456.svg";